<template>
    <div class="box">
        <div class="header">
            <Row v-if="hasPermission('addCorrelativeReport')" type="flex" class="toolbar">
                <Col span="24">
                <Button icon="md-add" type="primary" @click="$router.push('detail/0')">
                    {{ $t('liveRoomManagement.relatedReport.List.button.addRelatedReport') }}
                </Button>
                </Col>
            </Row>
            <div class="filter">
                <ul class="filter-box">
                    <li>
                        <span>{{ $t('liveRoomManagement.relatedReport.List.filter.titleLike') }}</span>
                        <Input
                            clearable
                            v-model="filter.titleLike"
                            size="small"
                            class="selector"
                            :placeholder="$t('Message.placeholder')"
                        />
                    </li>
                    <li v-if="dep||(filter.selectType==3)">
                        <span>{{ $t('liveRoomManagement.relatedReport.List.filter.userCode') }}</span>
                        <Input
                            clearable
                            v-model="filter.userCode"
                            size="small"
                            class="selector"
                            :placeholder="$t('Message.placeholder')"
                        />
                    </li>
                    <li>
                        <DepartmentSelect filterPath="views/relatedReport.all.filter"></DepartmentSelect>
                    </li>
                    <li v-if="filter.selectType == 3">
                            <UserGroupSelect v-model="groupIdSelected.id" ></UserGroupSelect>
                    </li>
                </ul>
                <Button 
                    class="refresh-button" 
                    type="primary" 
                    size="small"
                    @click="refresh">
                    {{ $t('Button.refresh') }}
                </Button>
            </div>
        </div>
        <div ref="list" class="content">
            <ul class="list">
                <li
                    :key="p.id"
                    v-for="p in list"
                    class="item"
                >
                    <div class="item-thumb">
                        <PrettyImage :src="p.imagePath"/>
                    </div>

                    <div class="item-info">
                        <span class="title">
                            <span :title="p.title">
                                {{p.title}}
                            </span>
                        </span>
                        <ul class="list">
                            <li>
                                <span class="title">{{ $t('liveRoomManagement.relatedReport.List.list.id') }}</span>
                                <span class="content">{{ p.id }}</span>
                            </li>
                            <li>
                                <span class="title">{{ $t('liveRoomManagement.relatedReport.List.list.userName') }}</span>
                                <span class="content">{{ p.userName }}</span>
                            </li>
                            <li>
                                <span class="title">{{ $t('liveRoomManagement.relatedReport.List.list.url') }}</span>
                                <span class="content">
                                    <a
                                        :href="p.url.substr(0,4).toLowerCase() == 'http' ? p.url : 'http://' + p.url"
                                        target="_blank"
                                    >{{ p.url }}</a>
                                </span>
                            </li>
                            <li>
                                <span class="title">{{ $t('liveRoomManagement.relatedReport.List.list.status.title') }}</span>
                                <span class="content">{{ p.status == 0 ? $t('liveRoomManagement.relatedReport.List.list.status.normal')
                                    : $t('liveRoomManagement.relatedReport.List.list.status.forbidden') }}</span>
                            </li>
                            <li>
                                <span class="title" >{{ $t('liveRoomManagement.relatedReport.List.list.publishDatetime') }}</span>
                                <span class="content">{{ p.publishDatetime }}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="item-op">
                        <Button
                                v-if="hasPermission('editCorrelativeReport')"
                                class="edit_btn"
                                type="dashed"
                                size="large"
                                icon="md-settings"
                                @click="e=>e.stopPropagation()"
                                :to="'detail/'+ p.id"
                        >{{ $t('Button.edit') }}</Button>
                        <Button
                                v-if="hasPermission('deleteCorrelativeReport')&&(p.userId==userId)"
                                type="dashed"
                                size="large"
                                icon="md-trash"
                                @click.stop="remove(p.id,p.title)"
                        >{{ $t('Button.remove') }}</Button><!--v-if="hasPermission('deleteCorrelativeReport')&&(p.userId==userId||filter.selectType!=3)" -->
                    </div>
                </li>
            </ul>

            <Spin v-show="loading" fix class="spin">
                <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
            <Page
                    class="pager"
                    :total="pagination.total"
                    :current="pagination.page"
                    :page-size="pagination.pageSize"
                    @on-change="v=>pagination.page=v"
                    @on-page-size-change="v=>pagination.pageSize=v"
                    show-elevator
                    show-sizer
                    transfer
            />
        </div>
    </div>
</template>

<script>
    import api from "@/api/Api";
    import extend from "extend";
    import PrettyImage from "@/components/PrettyImage";
    import DepartmentSelect from "../../../../components/DepartmentSelect";
    import UserGroupSelect from "../../../../components/UserGroupSelect"
    import HtmlDecode from "@/plugins/htmlDecode";
    import { mapState, mapMutations } from "vuex";
    export default {
        components: {
            UserGroupSelect,
            DepartmentSelect,
            PrettyImage
        },
        data(){
            
            return {
                groupIdSelected: {
                    id: this.$store.state.user.defaultSelectedUserGroup,
                    groupData: []
                },
                loading: true,
                list: []
            }
        },
        computed: {
            filter: {
                get() {
                    return this.$store.state.views.relatedReport.all.filter;
                },
                set(v) {
                    this.$store.commit("views/relatedReport.all.filter", v);
                }
            },
            pagination: {
                get() {
                    return this.$store.state.views.relatedReport.all.pagination;
                },
                set(v) {
                    this.$store.commit("views/relatedReport.all.pagination", v);
                }
            },
             ...mapState({
                userId: state => state.user.id,
                userName: state => state.user.name,
                departmentName: state => state.department.currentName,
                departmentId: state => state.department.currentId,
                shareId: state => state.user.defaultSelectedUserGroup
            }),
            dep(){
                return this.filter.selectType == 2
            }
        },
        watch: {
            'groupIdSelected.id'(){
                this.pagination.page = 1;
                this.refresh(); 
            },
            'filter.depId'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.titleLike'() {
                if(this.containsInvaildChar(this.filter.titleLike)) {
                    return;
                }
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.userCode'() {
                this.pagination.page = 1;
                this.refresh();
            },
            "pagination.page": "refresh",
            "pagination.pageSize": "refresh"
        },
        methods: {
            async remove(id, title) {
                if (!confirm(this.$t('Message.remove.confirm') + `(${title}) ?`)) return;

                let ret;
                try {
                    ret = await api.call("extendContent/delete", {
                        id: id,
                        twoDelete: false
                    }, null, true);

                    this.$Notice.success({ title: this.$t('Message.remove.success') + `(${title})` });

                    this.refresh();
                } catch (e) {
                    if(e.result == 4){
                        if (!confirm(this.$t('liveRoomManagement.relatedReport.List.message.remove.confirm'))) return;
                        try {
                            ret = await api.call("extendContent/delete", {
                                id: id,
                                twoDelete: true
                            }, null, true);

                            this.$Notice.success({ title: this.$t('Message.remove.success') + `(${title})` });

                            this.refresh();
                        } catch (e) {
                            this.$Notice.error({ title: this.$t('Message.remove.error') + `(${title})`, desc: e });
                        }
                    }else {
                        try {
                            ret = await api.call("extendContent/delete", {
                                id: id,
                                twoDelete: true
                            }, null, true);

                            this.$Notice.success({ title: this.$t('Message.remove.success') + `(${title})` });

                            this.refresh();
                        } catch (e) {
                            this.$Notice.error({ title: this.$t('Message.remove.error') + `(${title})`, desc: e });
                        }
                    }
                }
            },
            async refresh() {
                this.loading = true;

                try {
                    let param = extend(true, {}, this.pagination, this.filter);
                    if(this.filter.selectType == 3){
                        param.shareId = this.shareId
                    }
                    let ret = await api.call(
                        "extendContent/list",
                        param
                    );
                    // decode i.name if ret.list is not empty
                    if(ret.list) {
                        ret.list.forEach(i => {
                            i.title = HtmlDecode.d(i.title);
                        });
                    }
                    this.list = ret.list;
                    this.pagination.total = ret.total;
                } catch (e) {
					this.$Notice.error({
						title: this.$t(e && e.reject ?
							'Message.permission.error' :
							'Message.callResult.retry')
					});
					this.list = [];
                    this.pagination.total = 0;
                }

                this.loading = false;
            }
        },
        mounted() {
            this.refresh();
        }
    }
</script>

<style lang="less" scoped>
    @keyframes spin1 {
        from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .box {
        min-height:400px
    }
    .header {
        & > * {
            margin-bottom: 10px;
            border-radius: 5px;
        }
        .toolbar {
            height: 32px;
            line-height: 32px;

            button {
                margin-right: 22px;
                vertical-align: middle;
            }
        }
        .filter {
            padding: 10px 20px;
            background: #fff;

            .filter-box {
                list-style: none;
                display: inline-block;
                & > li {
                    display: inline-block;
                }
            }
        }
    }
    .content {
        position: relative;
        border-radius: 5px;
        background: white;
        padding: 0 20px;

        .spin {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
    }
    .list {
        list-style: none;
        padding: 0 7px;
        border-radius: 5px;
        background: white;

        .item {
            border-bottom: 1px solid #e9e9e8;
            height: 140px;
            padding: 15px 0;
            white-space: nowrap;
            position: relative;
            display: flex;
            align-items: center;

            .title-tag {
                border-radius: 5px;
                font-size: 12px;
                background: #e3e3e3;
                padding: 2px;
            }
            .item-thumb {
                height: 90px;
                // 如果设置 line-height: 90px 内容会下移1px，原因不明
                line-height: 89px;
                width: 160px;
                border-radius: 5px;
                overflow: hidden;
                margin-right: 12px;
                position: relative;
                flex-shrink: 0;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    vertical-align: middle;
                    border: 0;
                }
                canvas {
                    width: 100%;
                    border: 0;
                    vertical-align: middle;
                }
                .view {
                    width: 160px;
                    height: 90px;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
                .view:hover {
                    cursor: pointer;
                    background: rgba(0, 0, 0, 0.3);
                }
                .view-icon {
                    visibility: hidden;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin: -12px 0 0 -12px;
                    color: #ffffff;
                    z-index: 1000;
                }
                .view:hover .view-icon {
                    visibility: visible;
                }
                .view:hover .play-btn {
                    visibility: visible;
                }
                .play-btn {
                    visibility: hidden;
                    width: 40px;
                    height: 40px;
                    font-size: 30px;
                    position: absolute;
                    cursor: pointer;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    background: rgba(255, 255, 255, 0.5);
                    box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 10px;
                    border-radius: 40px;
                    i {
                        width: 100%;
                        height: 100%;
                        line-height: 40px;
                        text-align: center;
                        vertical-align: top;
                        padding-left: 5px;
                    }
                }
                .play-btn:hover {
                    background: #fff;
                }
            }
            .item-info {
                width: 0;
                flex-grow: 1;
                & > .title {
                    font-size: 15px;
                    color: #666;
                    & > * {
                        vertical-align: middle;
                    }
                    a {
                        margin-left: 5px;
                    }
                }
                .list {
                    color: #989898;
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    line-height: 19px;

                    li {
                        display: flex;

                        .title {
                            flex-shrink: 0;
                        }

                        .content {
                            flex-grow: 1;
                            width: 0;

                            a {
                                display: block;
                                width: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                        }
                    }

                    .title {
                        width: 60px;
                        display: inline-block;
                    }
                    .title:after {
                        content: ":";
                    }
                }
            }
            .item-op {
                flex-shrink: 0;
                align-self: flex-start;
                width: 100px;
                display: flex;
                flex-direction: column;
                
                .delete_btn2 {
                    display: none;
                }
                .default_btn{
                    background-color: yellow;
                }
            }
        }
    }
    .pager {
        text-align: center;
        padding: 10px;
    }

    .selector {
        display: inline-block;
        width: auto;
    }
</style>